
import Usuario from "@/objetos/usuario";
const time_span = 180000;

const manejador_sesiones = function() {  
       
    setTimeout(function(){ 
        this.$cookie.delete('pwst');
        this.$router.push("/home");        
    }.bind(this), Usuario.tiempo_sesion - time_span);
}

export default  manejador_sesiones
